export default __webpack_public_path__ + "static/media/yacht_news.917d1a26.svg";